import { inputMediumStyles, Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SearchField } from '@bechtel/client-common';
import { EventNotificationSortByTerm } from '@bechtel/types';

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    ::placeholder {
      color: ${theme.colors.grey[1000]};
    }
    :-ms-input-placeholder {
      color: ${theme.colors.grey[1000]};
    }
    ::-ms-input-placeholder {
      color: ${theme.colors.grey[1000]};
    }
  `}
  ${inputMediumStyles}
`;

export const FooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'space-between' } })`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    width: auto;
    background-color: ${theme.colors.bechtel.blue[700]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    white-space: nowrap;
  `}
`;

export const TableStyled = styled.table`
  text-align: left;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  ${({ theme }) => css`
    td,
    th {
      border: 1px solid ${theme.colors.grey[300]};
      padding: ${theme.spacings[500]};
    }
    th {
      background-color: ${theme.colors.grey[100]};
      z-index: 1;
      vertical-align: middle;
    }
    td {
      background-color: ${theme.colors.white};
      z-index: 0.9;
    }
    tr td:last-child,
    tr th:last-child {
      position: sticky;
      right: 0;
      top: 0;
    }
    tr th:last-child div {
      justify-content: center;
    }
    tr td:last-child div {
      justify-content: center;
      cursor: pointer;
    }
  `}
`;
interface TableHeaderStickyStyledProps {
  sortKey?: EventNotificationSortByTerm;
}

const getColumnWidth = (props: TableHeaderStickyStyledProps) => {
  switch (props.sortKey) {
    case EventNotificationSortByTerm.ENTITY_TYPE_ID:
    case EventNotificationSortByTerm.CREATED_AT:
      return css`
        max-width: 110px;
        min-width: 110px;
      `;
    case EventNotificationSortByTerm.STATUS:
      return css`
        max-width: 90px;
        min-width: 90px;
      `;
    case EventNotificationSortByTerm.RETRY_COUNT:
      return css`
        max-width: 120px;
        min-width: 120px;
      `;
    default:
      return css`
        max-width: 100px;
        min-width: 100px;
      `;
  }
};

export const TableHeaderStickyStyled = styled.th<TableHeaderStickyStyledProps>`
  position: sticky;
  top: 0;
  left: 0;
  vertical-align: top;
  ${getColumnWidth};
`;

export const SubContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  ml: { sm: '400' },
  mr: { sm: '300' },
  flexDirection: { sm: 'column' },
})`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-left-radius: ${({ theme }) => theme.radii[200]};
  border-top-right-radius: ${({ theme }) => theme.radii[200]};
  overflow-y: auto;
  position: relative;
`;

export const TableColumnStyled = styled.td<TableHeaderStickyStyledProps>`
  ${getColumnWidth};
`;
